import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
import DataTable from "react-data-table-component";

const columns = [
  {
    id: 1,
    name: "Invoice No",
    selector: (row) => row.meta.invoice_no,
    sortable: true,
    compact: true,
    reorder: true,
  },
  {
    id: 2,
    name: "Name",
    selector: (row) => row.meta.name,
    sortable: true,
    compact: true,
    reorder: true
  },
  {
    id: 3,
    name: "Amount",
    selector: (row) => row.meta.total_amount,
    sortable: true,
    compact: true,
    reorder: true
  },
  {
    id: 4,
    name: "VAT",
    selector: (row) => row.meta.vat,
    sortable: true,
    compact: true,
    reorder: true
  },
  {
    id: 5,
    name: "Total",
    selector: (row) => row.meta.total_after_vat,
    sortable: true,
    compact: true,
    reorder: true
  },
  {
    id: 6,
    name: "Date",
    selector: (row) => row.date.slice(0, 10),
    sortable: true,
    compact: true,
    reorder: true
  },
  {
    id: 7,
    name: "View",
    compact: true,
    cell: (row) => <Link to={`${slugs.invoices_details}${row.slug}`}>View</Link>,

  }
];

export default function AllInvoices() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [deleteUsersModal, setDeleteUsersModal] = React.useState(false)
  const [serachName, setSearchName] = React.useState("")
  const [TotalToday, setTotalToday] = React.useState("")
  const [TotalTodayVAT, setTotalTodayVAT] = React.useState("")
  const [TotalTodayAmount, setTotalTodayAmount] = React.useState("")

  const [Total, setTotal] = React.useState("")
  const [TotalVAT, setTotalVAT] = React.useState("")
  const [TotalAmount, setTotalAmount] = React.useState("")

  const dmyToIso = (date) => {
    const year = date.getFullYear()
    const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
    const day = date.getDate() < 9 ? `0${date.getDate()}` : `${date.getDate()}`
    return `${year}-${month}-${day}`
  };
  const date = new Date()

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta,date"
      }, slugs.db_slug_invoices)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)

        const ExpenseToday = res.data.filter(a => a.date.includes(dmyToIso(date)))
        var todayTotal = 0;
        var todayTotalVAT = 0;
        var todayTotalAmount = 0;
        for (let i = 0; i < ExpenseToday.length; i++) {
          todayTotal += Number(ExpenseToday[i].meta.total_after_vat)
          todayTotalVAT += Number(ExpenseToday[i].meta.vat)
          todayTotalAmount += Number(ExpenseToday[i].meta.total_amount)
        }
        setTotalToday(todayTotal)
        setTotalTodayVAT(todayTotalVAT)
        setTotalTodayAmount(todayTotalAmount)
        const ExpenseSelect = res.data
        var Total = 0;
        var TotalVAT = 0;
        var TotalAmount = 0;
        for (let i = 0; i < ExpenseSelect.length; i++) {
          Total += Number(ExpenseSelect[i].meta.total_after_vat)
          TotalAmount += Number(ExpenseSelect[i].meta.total_amount)
          TotalVAT += Number(ExpenseSelect[i].meta.vat)
        }
        setTotal(Total)
        setTotalVAT(TotalVAT)
        setTotalAmount(TotalAmount)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects()
  }, [])


  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Invoices</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Invoices
        </div>
      </div>
      <a href={slugs.new_invoices}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}>
          Add New Invoices
        </div>
      </a>


      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setCustomersList(Projects1)
              }}
            >
              All ({Projects1.length}) |
            </div>

          </div>
          {/* <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setDeleteUsersModal(Projects1)
              }}
            >
              Delete All
            </div>
          </div> */}
        </div>
        <div className="col-md-6 row">
          {/* <div className="col-6" /> */}
          <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setCustomersList(Projects1.filter(a => a.title.rendered.includes(event.target.value)))
            }}
          />
          <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Date" type="date"
            onChange={(event) => {
              // setSearchName(event.target.value)
              console.log(event.target.value)
              const ExpenseSelect = Projects1.filter(a => a.date.includes(event.target.value))
              setCustomersList(Projects1.filter(a => a.date.includes(event.target.value)))
              var Total = 0;
              var TotalVAT = 0;
              var TotalAmount = 0;
              for (let i = 0; i < ExpenseSelect.length; i++) {
                Total += Number(ExpenseSelect[i].meta.total_after_vat)
                TotalAmount += Number(ExpenseSelect[i].meta.total_amount)
                TotalVAT += Number(ExpenseSelect[i].meta.vat)
              }
              setTotal(Total)
              setTotalVAT(TotalVAT)
              setTotalAmount(TotalAmount)
            }}
          />
        </div>
      </div>
      <div style={{ margin: "0px 5px" }}>
        Today: &nbsp; Amount: {TotalTodayAmount} &nbsp; VAT: {TotalTodayVAT}&nbsp; Total: {TotalToday}
      </div>
      <div style={{ margin: "0px 5px" }}>
        Total: &nbsp; Amount: {TotalAmount} &nbsp; VAT: {TotalVAT}&nbsp; Total: {Total}
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          pagination
          selectableRows
        />
      </div>
      {deleteUsersModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setDeleteUsersModal(false)
                  }}
                >X</div>
                Do you really want to Delete all the invoices?<br />
                <div className="row">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setDeleteUsersModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        for (let i = 0; i < Projects1.length; i++) {
                          setReload(true)
                          setDeleteUsersModal(false)
                          AdsPUTApi({
                            status: "draft"
                          }, slugs.db_slug_invoices, Projects1[i].id)
                            .then((res) => {
                              if (i == Projects1.length - 1) {
                                GetAllProjects()
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })

                        }
                      }}
                    >
                      Delete all Invoices
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <DataTable
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[10, 50, 100, 1000]}
                    columns={columns}
                    data={Projects1}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    striped
                    // sortIcon={<SortIcon />}
                    pagination
                    selectableRows={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

      }
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}